var _rect, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgArrowUp(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "current",
    height: "current",
    viewBox: "0 0 42 43",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_778_252",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 42,
    height: 43
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 42,
    y: 0.5,
    width: 42,
    height: 42,
    transform: "rotate(90 42 0.5)",
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_778_252)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.22501 19.5312L19.775 7.98125C19.95 7.80625 20.1396 7.682 20.3438 7.6085C20.5479 7.53617 20.7667 7.5 21 7.5C21.2333 7.5 21.4521 7.53617 21.6563 7.6085C21.8604 7.682 22.05 7.80625 22.225 7.98125L33.775 19.5313C34.0958 19.8521 34.2638 20.2528 34.279 20.7335C34.293 21.2153 34.125 21.6313 33.775 21.9813C33.4542 22.3313 33.0534 22.5138 32.5728 22.529C32.0909 22.543 31.675 22.375 31.325 22.025L22.75 13.45L22.75 33.0063C22.75 33.5021 22.5826 33.918 22.2478 34.254C21.9118 34.5888 21.4958 34.7563 21 34.7563C20.5042 34.7563 20.0888 34.5888 19.754 34.254C19.418 33.918 19.25 33.5021 19.25 33.0063L19.25 13.45L10.675 22.025C10.3542 22.3458 9.94584 22.5138 9.45001 22.529C8.95418 22.543 8.54584 22.375 8.22501 22.025C7.87501 21.7042 7.70001 21.2958 7.70001 20.8C7.70001 20.3042 7.87501 19.8812 8.22501 19.5312Z",
    fill: "white"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowUp);
export default __webpack_public_path__ + "static/media/arrow_up.46ef4f6a25cb265ec84c34dd5a3719c9.svg";
export { ForwardRef as ReactComponent };